import React, { useEffect, useState } from "react";
// import Filter from '../../../WelcomeBackMsg/WelcomeBack.jsx';
import { BiPencil } from "react-icons/bi";
import { BsInfoCircle } from "react-icons/bs";
import { CiCalendar, CiLocationOn, CiMail } from "react-icons/ci";
import { FiServer } from "react-icons/fi";
import { HiOutlineUserAdd } from "react-icons/hi";
import { HiOutlineClipboard } from "react-icons/hi2";
import { MdOutlineNoteAdd } from "react-icons/md";
import {
  PiPhoneCallLight,
  PiQuestionLight,
  PiShareFatLight,
} from "react-icons/pi";
import { TbCalendarPlus } from "react-icons/tb";
import { Link } from "react-router-dom";
import "./TuitionManagementSystem.css";
import axios from "axios";

const TuitionManagementSystem = () => {
  const [homeTutorRequest, setHomeTutorRequest] = useState([]);
  const [requestFilter, setRequestFilter] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  useEffect(() => {
    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/home-tutor/requests?status=${requestFilter}`
        : `${API_BASE_URL}/admin/home-tutor/requests?status=${requestFilter}`;

    axios
      .get(
        // `${API_BASE_URL}/admin/home-tutor/requests?status=${requestFilter}`,
        endpoint,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data?.data);
        const data = response.data?.data;
        setHomeTutorRequest(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_BASE_URL, requestFilter]);
  return (
    <>
      <div id="tuition-management-system-home-tutor-students-main">
        {/* <Filter></Filter> */}
        <h1>
          <b>List Of Student Request Status</b>
        </h1>

        <div className="push-notification-input w-50 ms-3 my-3">
          <label>
            <b>Filter Request</b>
          </label>
          <select
            value={requestFilter}
            onChange={(e) => setRequestFilter(e.target.value)}
          >
            <option value="">All Student</option>
            <option value="assigned">Assigned</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
          </select>
        </div>

        {homeTutorRequest &&
          homeTutorRequest.map((item, idx) => (
            <div className="home-tutor-student-profile-container border" key={idx}>
              <div className="home-tutor-student-image-box">
                <img
                  src={require("../../../../Images/student-profile-img.png")}
                  alt="student-img"
                />
              </div>

              <div className="home-tutor-student-details-box">
                <p className="student-name-b">
                  <b>
                    {item.name}
                    <span className="tuition-per-month-fee-amount">
                      <img
                        src={require("../../../../Images/rupee-icon.png")}
                        alt=""
                      />{" "}
                      {item.budget} /m
                      <BiPencil
                        style={{ fontSize: "14px", marginLeft: "5px" }}
                      />
                    </span>
                  </b>
                </p>
                <p
                  className="tuition-joining-date"
                  style={{ position: "absolute", top: "10px", right: "20px" }}
                >
                  <CiCalendar
                    className="icon-margin"
                    style={{ fontSize: "20px" }}
                  />
                  {new Date(item.createdAt).toISOString().split("T")[0]}
                </p>
                <p className="student-phone-and-email">
                  <span className="student-contact">
                    <PiPhoneCallLight className="icon-margin" />
                    {item.mobile}
                  </span>
                </p>

                <p className="student-class-and-subject">
                  <span className="student-class">
                    <HiOutlineClipboard className="icon-margin" />
                    {item.className}
                  </span>
                  <span className="student-subjects">
                    <FiServer className="icon-margin" />
                    {item.subjects &&
                      item.subjects.map((sub, idx) => (
                        <span key={idx}>{sub} ,</span>
                      ))}
                  </span>
                </p>
                <p className="student-class-and-subject">
                  <span>Preferred Language : </span>
                  {item.subjects &&
                    item.preferredLanguage.map((sub, idx) => (
                      <span key={idx}>{sub} ,</span>
                    ))}
                </p>
                <p>
                  <span>
                    Address : {item?.address} , {item?.city} , {item?.state} ,{" "}
                    {item?.pinCode}
                  </span>
                </p>
                <p className="student-teacher-gender">
                  <span>Teacher Preference : </span>
                  {item.gender}
                </p>
                <p className="rejected-accepted-requests-and-forwards d-flex justify-content-center align-content-center">
                  <div className="d-flex justify-content-center align-content-center gap-2">
                    <p className="my-auto mt-4">
                      Admin Status :{" "}
                      <span className="border border-2 px-4 py-2">{item.status}</span>
                    </p>
                  </div>
                  {item.status === "pending" ? (
                    <span className="add-user">
                      <Link to={`./tms-share/${item._id}`}>
                        <PiShareFatLight className="share-icon-btn icon-margin" />
                      </Link>
                    </span>
                  ) : null}
                </p>
                <p className="d-flex justify-content-start align-content-center gap-2">
                  <p className="my-auto mt-4">
                    Teacher Status :{" "}
                    <span className="border border-2 px-4 py-2">{item.status}</span>
                  </p>
                </p>
                <p></p>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default TuitionManagementSystem;
